var _g, _g2, _path, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessengerIsActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6730_35030)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3181 14.8185C25.3181 10.2998 21.655 6.63672 17.1363 6.63672C12.6176 6.63672 8.95448 10.2998 8.95448 14.8185C8.95448 19.3372 12.6176 23.0004 17.1363 23.0004C18.5725 23.0004 19.9238 22.6298 21.0982 21.9787C21.17 21.9389 21.24 21.9372 21.2898 21.9548L23.2098 22.6332C24.3861 23.0489 25.5193 21.9157 25.1036 20.7394L24.3971 18.74C24.3801 18.692 24.3809 18.625 24.4169 18.5549C24.9931 17.4342 25.3181 16.1635 25.3181 14.8185Z",
    fill: "url(#paint0_linear_6730_35030)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_6730_35030)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.68188 11.1818C1.68188 6.66312 5.34501 3 9.8637 3C14.3824 3 18.0455 6.66312 18.0455 11.1818C18.0455 15.7005 14.3824 19.3636 9.8637 19.3636C8.42753 19.3636 7.07619 18.9931 5.90181 18.342C5.82995 18.3022 5.76003 18.3005 5.71018 18.3181L3.79024 18.9965C2.61389 19.4122 1.48075 18.279 1.89642 17.1027L2.60293 15.1032C2.61989 15.0553 2.61911 14.9883 2.58306 14.9182C2.00685 13.7975 1.68188 12.5268 1.68188 11.1818Z",
    fill: "url(#paint1_linear_6730_35030)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8637 2.5C5.06887 2.5 1.18188 6.38698 1.18188 11.1818C1.18188 12.5706 1.50874 13.8859 2.09059 15.0524L1.42499 16.9361C0.869276 18.5087 2.38417 20.0236 3.95683 19.4679L5.75611 18.8321C6.98002 19.4905 8.37981 19.8636 9.8637 19.8636C14.6585 19.8636 18.5455 15.9767 18.5455 11.1818C18.5455 6.38698 14.6585 2.5 9.8637 2.5Z",
    stroke: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_6730_35030)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.68188 11.1818C1.68188 6.66312 5.34501 3 9.8637 3C14.3824 3 18.0455 6.66312 18.0455 11.1818C18.0455 15.7005 14.3824 19.3636 9.8637 19.3636C8.42753 19.3636 7.07619 18.9931 5.90181 18.342C5.82995 18.3022 5.76003 18.3005 5.71018 18.3181L3.79024 18.9965C2.61389 19.4122 1.48075 18.279 1.89642 17.1027L2.60293 15.1032C2.61989 15.0553 2.61911 14.9883 2.58306 14.9182C2.00685 13.7975 1.68188 12.5268 1.68188 11.1818Z",
    fill: "url(#paint2_linear_6730_35030)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_6730_35030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3617 11.2215C7.3617 11.8335 6.86554 12.3297 6.2535 12.3297C5.64146 12.3297 5.14531 11.8335 5.14531 11.2215C5.14531 10.6094 5.64146 10.1133 6.2535 10.1133C6.86554 10.1133 7.3617 10.6094 7.3617 11.2215Z",
    fill: "url(#paint3_linear_6730_35030)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9417 11.2215C10.9417 11.8335 10.4455 12.3297 9.83349 12.3297C9.22145 12.3297 8.7253 11.8335 8.7253 11.2215C8.7253 10.6094 9.22145 10.1133 9.83349 10.1133C10.4455 10.1133 10.9417 10.6094 10.9417 11.2215Z",
    fill: "url(#paint4_linear_6730_35030)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5217 11.2215C14.5217 11.8335 14.0255 12.3297 13.4135 12.3297C12.8014 12.3297 12.3053 11.8335 12.3053 11.2215C12.3053 10.6094 12.8014 10.1133 13.4135 10.1133C14.0255 10.1133 14.5217 10.6094 14.5217 11.2215Z",
    fill: "url(#paint5_linear_6730_35030)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6730_35030",
    x: 8.95448,
    y: 6.63672,
    width: 16.3636,
    height: 16.3633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6730_35030"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_6730_35030",
    x: 0.681885,
    y: 2,
    width: 18.3636,
    height: 18.3633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6730_35030"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_6730_35030",
    x: 1.68188,
    y: 3,
    width: 16.3636,
    height: 16.3633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6730_35030"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_6730_35030",
    x: 5.14531,
    y: 10.1133,
    width: 9.37636,
    height: 2.21484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6730_35030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6730_35030",
    x1: 19.5,
    y1: 6.63672,
    x2: 20.75,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA15E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6730_35030",
    x1: 9.8637,
    y1: 3,
    x2: 9.8637,
    y2: 19.3636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD5DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6730_35030",
    x1: 16.066,
    y1: 3,
    x2: 1.68188,
    y2: 19.3636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6730_35030",
    x1: 7.09358,
    y1: 10.1133,
    x2: 5.14531,
    y2: 12.3297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE5B2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6730_35030",
    x1: 10.6736,
    y1: 10.1133,
    x2: 8.7253,
    y2: 12.3297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE5B2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6730_35030",
    x1: 14.2536,
    y1: 10.1133,
    x2: 12.3053,
    y2: 12.3297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE5B2D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerIsActive);
export default __webpack_public_path__ + "static/media/messengerIsActive.0f593a0473d486f45478ff29d6ec0b48.svg";
export { ForwardRef as ReactComponent };